import { energyAnalysisApiSlice } from '@/api/apiSlice';
import { useGetPortfolioAnalysisSubscriptionQuery } from '@/api/energy-analysis/portfolioAnalysisApiSlice';
import AppBar from '@/features/portfolio-analysis/components/AppBar';
import DataIntegrityDialog from '@/features/portfolio-analysis/components/data-integrity/DataIntegrityDialog';
import { getSelectedAccount } from '@/redux/selectedAccountSlice';
import { Container } from '@mui/material';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const PortfolioAnalysisPageWrapper = ({ children }) => {
  const account = useSelector(getSelectedAccount);
  const dispatch = useDispatch();
  const { data: subscriptionData } = useGetPortfolioAnalysisSubscriptionQuery(
    { recalc_account_id: account?.AccountId },
    {
      skip: !account?.AccountId,
      pollingInterval: 60000,
      skipPollingIfUnfocused: true,
    },
  );

  const excludedAnalysisTypes = useMemo(() => {
    let result = ['power', 'water', 'heat'];
    if (!subscriptionData) return result;
    // filters list to only include types where subscriptionData.[type] == true
    result = result.filter((type) => !subscriptionData[type]);
    return result;
  }, [subscriptionData]);

  const prevOutOfSyncRef = React.useRef(false);

  const outOfSync = useMemo(() => {
    let types = ['power_in_sync', 'water_in_sync', 'heat_in_sync'];
    if (!subscriptionData) return false;
    // filters list to only include types where subscriptionData.[type] == true
    return !types.every((type) => subscriptionData[type]);
  }, [subscriptionData]);

  React.useEffect(() => {
    if (prevOutOfSyncRef.current === true && outOfSync === false) {
      dispatch(
        energyAnalysisApiSlice.util.invalidateTags(['PortfolioAnalysis']),
      );
    }
    prevOutOfSyncRef.current = outOfSync;
  }, [outOfSync, dispatch]);
  return (
    <Container key={account.AccountId} maxWidth="xxl" height="100%">
      <AppBar
        excludedAnalysisTypes={excludedAnalysisTypes}
        outOfSync={outOfSync}
      />
      <Container maxWidth="xl" height="100%" disableGutters>
        {children}
      </Container>
      <DataIntegrityDialog />
    </Container>
  );
};

export default PortfolioAnalysisPageWrapper;
